import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import Info from "./Info";
import MyRol from "./MyRol";
import Preview from "./Preview";

function ProjectDetail() {
    
    const {lang, project} = useContext(GlobalContext)
    
    console.log(project);
    const {projectid} = useParams()

    const [projectName, setProjectName] = useState(project.id.split('_').join(' '))

    console.log(project);

    const select = (id) => {

        const head = document.getElementsByClassName("projectDetail__underline")
        const projDet = document.getElementsByClassName("projDet")
        const sel = document.getElementById(id + "-sel")
        const projSel = document.getElementById(id + "-det")
        console.log(head);

        for(let i = 0; i < head.length; i++){
            head[i].style.width = "0"
            projDet[i].style.width = "0"      
        }

        setTimeout(() => {
            for(let i = 0; i < head.length; i++){
                projDet[i].style.height = "0"
                sel.style.width = "100%"
                projSel.style.width = "100%"
            }
            projSel.style.height = "auto" 
        }, 200);        
    }


    return(
        <div className="projectDetail">
            <div className="projectDetail__header">
                <Link to="/projects" className="projectDetail__arrow" id="arrow"><span>←</span>{lang === "ingles" ? "Back" : "Volver"}</Link>
                <div className="projectDetail__head" onClick={() => select("preview")}>
                    <h4 className="projectDetail__preview head" >{lang === "ingles" ? "Preview" : "Vista"}</h4>
                    <div className="projectDetail__underline" id="preview-sel"></div>
                </div>
                <div className="projectDetail__head" onClick={() => select("myRol")}>
                    <h4 className="projectDetail__myRol head">{lang === "ingles" ? "My Rol" : "Mi Rol"}</h4>
                    <div className="projectDetail__underline" id="myRol-sel"></div>
                </div>
                <div className="projectDetail__head" onClick={() => select("info")}>
                    <h4 className="projectDetail__info head" >+Info</h4>
                    <div className="projectDetail__underline" id="info-sel"></div>
                </div>
            </div>

            <div className="projectDetail__details">
                <Preview 
                    link = {project.link}
                    imgURL = {project.imagesURL}
                    imgDesc = {project.imgDesc}
                />
                <MyRol 
                    rol = {project.rol}
                    tasks = {project.task}
                />
                <Info 
                    longDesc = {project.longDesc}
                    coworkers = {project.coworkers}
                />
            </div>
        </div>
    )
}

export default ProjectDetail